import { FiltersAppliedWarningMessage, Main, PageSubHeader, ThemedIcon } from "../../components/utilities";
import ProviderManagementProvider, { useProviderManagement } from "./hooks/ProviderManagementContext";
import { IconButton } from "../../components";
import FilterProvidersModal from "./components/FilterProvidersModal";
import { ConfirmModal } from "../../components/modals";
import EditProviderModal from "./components/EditProviderModal";
import React, { useState } from "react";
import toast from "react-hot-toast";
import { useFilterContext } from "../../hooks/FilterContext";
import ProvidersGrid from "./components/ProvidersGrid";


const ProvidersHeader = () => {
    const [isFiltersShown, setIsFiltersShown] = useState(false);
    const {
        createProvider,
        createResult,
        deleteProvider,
    } = useProviderManagement();

    const {
        clearFilter,
        isFiltersApplied,
    } = useFilterContext();

    const onCreate = (e) => {
        e.preventDefault();

        toast.promise(createProvider(), {
            loading: "Creating provider...",
            error: "Unable to create provider.",
            success: "Provider created!"
        });
    };

    return (
        <>
            <PageSubHeader>
                <div className="d-flex justify-content-between align-items-center">
                    <div className="d-flex align-items-center">
                        {isFiltersApplied && (
                            <React.Fragment>
                                <ThemedIcon icon="fa-triangle-exclamation" size="2x" variant="warning" />
                                <FiltersAppliedWarningMessage className="ms-2 text-muted">
                                    Warning - Filters are currently being applied to your results.
                                    <br />
                                    <a href="#" onClick={clearFilter}>Click here</a> to clear your filters.
                                </FiltersAppliedWarningMessage>
                            </React.Fragment>
                        )}
                    </div>
                    <div className="d-flex flex-fill justify-content-end align-items-center gap-2">
                        <IconButton icon={['fas', 'filter']} onClick={() => setIsFiltersShown(true)}>
                            Filter Providers
                        </IconButton>
                        <IconButton
                            icon={"fa-plus"}
                            onClick={onCreate}
                            disabled={createResult.isLoading}
                            variant="success"
                        >
                            Create New Provider
                        </IconButton>
                    </div>
                </div>
            </PageSubHeader>
            <FilterProvidersModal
                show={isFiltersShown}
                onHide={() => setIsFiltersShown(null)}
            />
            <EditProviderModal />
        </>
    )
};

const ProvidersManagement = () => (
    <ProviderManagementProvider>
        <Main className="d-flex flex-column">
            <ProvidersHeader />
            <section className="px-4 my-3 h-100">
                <ProvidersGrid />
            </section>
        </Main>
    </ProviderManagementProvider>
);

export default ProvidersManagement;